import { environment } from "../config/environment";
import { useSWRFetcher } from "./useSWRFetcher";
import { useContext } from "react";
import { ToastContext } from "../context/ToastContext";
import { EmailActionResponseModel } from "../models/EmailActionModels";
import useSWR from "swr";
import { useEmailId } from "./useEmailId";

export const useEmailActions = () => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);
  const emailId = useEmailId();

  const { data, isLoading, error, mutate } = useSWR<EmailActionResponseModel>(
    emailId ? `${environment.apiUrl}/api/emails/actions/${emailId}` : null,
    (url: string) => fetcher(url),
    {
      onError: () => {
        showToast("The email actions failed to load, please try again later", "error");
      },
    }
  );
  return {
    emailActions: data,
    isLoading,
    isError: !!error,
    mutate,
  };
};
